export default {
      id: "social-whatsapp-usage",
      viewBox: "0 0 448 512",
      url: "/dist/svg/" + "sprite.svg#social-whatsapp-usage",
      toString: function () {
        return this.url;
      }
    }